import React from "react";
import { generateConfigData, generateInfoCard, processLink, generateLink } from "Common/utility/infoCard"
import { generateCardsJson } from "Common/utility/serialize";
import CommonConfiramation from "../../../js/common/base/CommonConfiramation/CommonConfiramation";

const ALLOWED_TAGS = new Set(['ul', 'ol', 'li', 'strong', 'em', 'b', 'i', 'p', 'br', 'span', 'div', 'a']);

function isSafeHref(href) {
    try {
        const url = new URL(href, window.location.href);
        return url.protocol === 'https:' || url.protocol === 'http:' || url.protocol === 'mailto:';
    } catch (e) {
        // relative URLs that fail URL parsing are safe
        return href.startsWith('/') || href.startsWith('#') || href.startsWith('.');
    }
}

export default class PortalGroupCard extends React.Component {
    constructor(props) {
        super(props);
        this.isAuthenticated = window.sessionStorage.getItem("isAuthenticated");

        this.state = {
            cards: [],
            sections: []
        };
        this.allCards = [];
    }

    componentDidMount() {
        const { config } = this.props;
        if (config) {
            const sections = config.querySelectorAll('section');
            const categorizedData = {};
            sections.forEach((section) => {
                const tabName = section.getAttribute('tab');
                const cards = Array.from(section.querySelectorAll('card')).map(card => ({
                    title: card.querySelector('title')?.textContent.trim(),
                    description: card.querySelector('description')?.innerHTML.trim(),
                    icon: card.querySelector('icon')?.textContent.trim(),
                    pageLink: card.querySelector('pagelink')?.textContent.trim(),
                }));

                categorizedData[tabName] = cards;
            });

            this.setState({
                sections: categorizedData,
            });
        }
    }

    domToReact = (node, key = 0) => {
        if (node.nodeType === Node.TEXT_NODE) {
            return node.textContent;
        }
        if (node.nodeType !== Node.ELEMENT_NODE) {
            return null;
        }
        const tag = node.tagName.toLowerCase();
        if (!ALLOWED_TAGS.has(tag)) {
            return null;
        }
        const children = Array.from(node.childNodes).map((child, i) => this.domToReact(child, i));
        const props = { key };
        if (tag === 'a') {
            const href = node.getAttribute('href') || '';
            if (isSafeHref(href)) {
                props.href = href;
                props.rel = "noopener noreferrer";
                const target = node.getAttribute('target');
                if (target && target !== '_self') {
                    props.target = target;
                }
            } else {
                // Unsafe href: render children without the anchor
                return React.createElement(React.Fragment, { key }, ...children);
            }
        }
        return React.createElement(tag, props, ...children);
    };

    parseDescription = (html) => {
        if (!html || typeof html !== 'string') return null;
        try {
            const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
            const root = doc.body.firstChild;
            if (!root) return null;
            return Array.from(root.childNodes).map((child, i) => this.domToReact(child, i));
        } catch (e) {
            return null;
        }
    };

    renderCards = (cards) => (
        <div className="pt-5 px-5">
            {cards.map((card, index) => (
                <React.Fragment key={index}>
                    {card.title && <strong>{card.title}:</strong>}
                    {card.description && <div>{this.parseDescription(card.description)}</div>}
                    {card.pageLink && this.isAuthenticated && 
                        <div className="pb-3 ps-3">
                            <a className="feature-link" href={"auth/#" + card.pageLink}>Go to {card.title} <i className="atm-pictogram general-wayfinding-arrow-up-right"></i></a>
                        </div>
                    }
                </React.Fragment>
            ))}
        </div>
    );
    render() {
        const { config } = this.props;
        const { sections, cards, searchVal, viewType, bgImage, IconImage } = this.state;

        if (!config) {
            return <span>Loading...</span>;
        }
        return (
            <>
                <div className="whats-new-container mt-3">
                    <hbr-tab-group primary>
                        {Object.keys(sections).map((tabName, index) => (
                            <hbr-tab
                                key={tabName}
                                slot="nav"
                                panel={tabName}
                            >
                                {tabName}
                            </hbr-tab>
                        ))}

                        {Object.entries(sections).map(([tabName, cards]) => (
                            <hbr-tab-panel key={tabName} name={tabName}>
                                {this.renderCards(cards)}
                            </hbr-tab-panel>
                        ))}
                    </hbr-tab-group>
                </div>

            </>
        )
    }
}